import authService from "../services/auth-service";
import { get, insert, update, remove } from "./labSlice";
import store from "./store";
import secureLocalStorage from "react-secure-storage";
export const get_users = async () => {
  const { u_id, u_type, parent_u_id, admin_u_id } =
    secureLocalStorage.getItem("userdata") || {};
  try {
    const response = await authService?.get_users({
      attributes: {
        u_id,
        u_type,
        parent_u_id,
        admin_u_id: u_type === 1 ? u_id : admin_u_id,
      },
    });
    if (response !== undefined) {
      let new_data = response?.data?.sort((a, b) => {
        return a?.u_id - b?.u_id;
      });
      store.dispatch(
        get({ name: "users", data: new_data, pages: [], fetch: true })
      );
      return { status: true, message: new_data };
    }
  } catch (res) {
    return { status: false, message: res };
  }
};
export const sendMail = async ({
  pcs,
  type,
  notification,
  showLoading,
  hideLoading,
}) => {
  const { admin_u_id } = secureLocalStorage.getItem("userdata") || {};

  try {
    showLoading();
    const response = await authService?.send_mail({
      attributes: { type: type, admin_u_id, data: pcs },
    });

    if (response) {
      notification({
        title: "Successfully!",
        message: response?.message,
        color: "success",
      });
    }
  } catch (error) {
    notification({
      title: "Error!",
      message: "Something went wrong!",
      color: "error",
    });
  } finally {
    hideLoading();
  }
};
export const get_sizes = async () => {
  const { u_id, u_type, parent_u_id, admin_u_id } =
    secureLocalStorage.getItem("userdata") || {};
  try {
    const response = await authService.get_sizes({
      attributes: {
        u_id,
        u_type,
        parent_u_id,
        admin_u_id: u_type === 1 ? u_id : admin_u_id,
      },
    });
    if (response !== undefined) {
      let new_data = response?.data?.sort((a, b) => {
        return a?.size_id - b?.size_id;
      });
      store.dispatch(
        get({ name: "sizes", data: new_data, pages: [], fetch: true })
      );
      return { status: true, message: new_data };
    }
  } catch (res) {
    return { status: false, message: res };
  }
};
export const get_services = async () => {
  const { u_id, u_type, parent_u_id, admin_u_id } =
    secureLocalStorage.getItem("userdata") || {};
  try {
    const response = await authService.get_services({
      attributes: {
        u_id,
        u_type,
        parent_u_id,
        admin_u_id: u_type === 1 ? u_id : admin_u_id,
      },
    });
    if (response !== undefined) {
      let new_data = response?.data?.sort((a, b) => {
        return a?.ser_id - b?.ser_id;
      });
      store.dispatch(
        get({ name: "services", data: new_data, pages: [], fetch: true })
      );
      return { status: true, message: new_data };
    }
  } catch (res) {
    return { status: false, message: res };
  }
};
export const get_parties = async () => {
  const { u_id, u_type, parent_u_id, admin_u_id } =
    secureLocalStorage.getItem("userdata") || {};
  try {
    const response = await authService.get_parties({
      attributes: {
        u_id,
        u_type,
        parent_u_id,
        admin_u_id: u_type === 1 ? u_id : admin_u_id,
      },
    });
    if (response !== undefined) {
      let new_data = response?.data?.sort((a, b) => {
        return a?.p_id - b?.p_id;
      });
      store.dispatch(
        get({ name: "parties", data: new_data, pages: [], fetch: true })
      );
      return { status: true, message: new_data };
    }
  } catch (res) {
    return { status: false, message: res };
  }
};
export const get_price_lists = async () => {
  const { u_id, u_type, parent_u_id, admin_u_id } =
    secureLocalStorage.getItem("userdata") || {};
  try {
    const response = await authService.get_pricelists({
      attributes: {
        u_id,
        u_type,
        parent_u_id,
        admin_u_id: u_type === 1 ? u_id : admin_u_id,
      },
    });
    if (response !== undefined) {
      let new_data = response?.data?.sort((a, b) => {
        return a?.pl_id - b?.pl_id;
      });
      store.dispatch(
        get({ name: "priceList", data: new_data, pages: [], fetch: true })
      );
      return { status: true, message: new_data };
    }
  } catch (res) {
    return { status: false, message: res };
  }
};
export const get_cnv_rates = async () => {
  const { u_id, u_type, parent_u_id, admin_u_id } =
    secureLocalStorage.getItem("userdata") || {};
  try {
    const response = await authService.get_cnv_rates({
      attributes: {
        u_id,
        u_type,
        parent_u_id,
        admin_u_id: u_type === 1 ? u_id : admin_u_id,
      },
    });
    if (response !== undefined) {
      let new_data = response?.data?.sort((a, b) => {
        return a?.cnv_id - b?.cnv_id;
      });
      store.dispatch(
        get({ name: "conversionRate", data: new_data, pages: [], fetch: true })
      );
      return { status: true, message: new_data };
    }
  } catch (res) {
    return { status: false, message: res };
  }
};

export const get_submissions = async () => {
  // const { u_id, u_type, parent_u_id, admin_u_id } =
  //   secureLocalStorage.getItem("userdata") || {};
  // try {
  //   const response = await authService.get_submissions({
  //     attributes: {
  //       u_id,
  //       u_type,
  //       parent_u_id,
  //       admin_u_id: u_type === 1 ? u_id : admin_u_id,
  //     },
  //   });
  //   if (response !== undefined) {
  //     let new_data = response?.data?.sort((a, b) => {
  //       return a?.stn_id - b?.stn_id;
  //     });
  //     store.dispatch(
  //       get({ name: "submissions", data: new_data, total: response?.total })
  //     );
  //     return { status: true, message: new_data };
  //   }
  // } catch (res) {
  //   return { status: false, message: res };
  // }
};
export const get_results = async () => {
  // const { u_id, u_type, parent_u_id, admin_u_id } =
  //   secureLocalStorage.getItem("userdata") || {};
  // try {
  //   const response = await authService.get_results({
  //     attributes: {
  //       u_id,
  //       u_type,
  //       parent_u_id,
  //       admin_u_id: u_type === 1 ? u_id : admin_u_id,
  //     },
  //   });
  //   if (response !== undefined) {
  //     let new_data = response?.data?.sort((a, b) => {
  //       return a?.res_id - b?.res_id;
  //     });
  //     store.dispatch(get({ name: "results", data: new_data }));
  //     return { status: true, message: new_data };
  //   }
  // } catch (res) {
  //   return { status: false, message: res };
  // }
};
export const get_replies = async () => {
  const { u_id, u_type, parent_u_id, admin_u_id } =
    secureLocalStorage.getItem("userdata") || {};
  try {
    const response = await authService.get_replies({
      attributes: {
        u_id,
        u_type,
        parent_u_id,
        admin_u_id: u_type === 1 ? u_id : admin_u_id,
      },
    });
    if (response !== undefined) {
      let new_data = response?.data?.sort((a, b) => {
        return a?.rep_id - b?.rep_id;
      });
      store.dispatch(get({ name: "replies", data: new_data }));
      return { status: true, message: new_data };
    }
  } catch (res) {
    return { status: false, message: res };
  }
};
export const get_returns = async () => {
  const { u_id, u_type, parent_u_id, admin_u_id } =
    secureLocalStorage.getItem("userdata") || {};
  try {
    const response = await authService?.get_returns({
      attributes: {
        u_id,
        u_type,
        parent_u_id,
        admin_u_id: u_type === 1 ? u_id : admin_u_id,
      },
    });
    if (response !== undefined) {
      let new_data = response?.data?.sort((a, b) => {
        return a?.ret_id - b?.ret_id;
      });
      store.dispatch(get({ name: "labouts", data: new_data }));
      return { status: true, message: new_data };
    }
  } catch (res) {
    return { status: false, message: res };
  }
};
export const get_bills = async () => {
  const { u_id, u_type, parent_u_id, admin_u_id } =
    secureLocalStorage.getItem("userdata") || {};

  try {
    const response = await authService.get_bills({
      attributes: {
        u_id,
        u_type,
        parent_u_id,
        admin_u_id: u_type === 1 ? u_id : admin_u_id,
      },
    });
    if (response !== undefined) {
      let new_data = response?.data?.sort((a, b) => {
        return a?.bill_id - b?.bill_id;
      });
      store.dispatch(get({ name: "bills", data: new_data }));
      return { status: true, message: new_data };
    }
  } catch (res) {
    return { status: false, message: res };
  }
};
export const manage_store_data = ({ name, key, data, type, total }) => {
  switch (type) {
    case "get":
      store?.dispatch(get({ name, data, total }));
      break;
    case "insert":
      store?.dispatch(insert({ name, data }));
      break;
    case "update":
      store?.dispatch(update({ name, data, key, total }));
      break;
    case "remove":
      store?.dispatch(remove({ name, data, key }));
      break;
    default:
      console.error("Unknown operation type:", type);
  }
};
export const manage_socket = (socketData) => {
  // Check if data contains an array of operations
  if (Array.isArray(socketData?.data)) {
    socketData.data.forEach((operation) => {
      const { key, response_data } = operation;
      let [operationType, entityType] = key.split("_");
      operationType = operationType === "delete" ? "remove" : operationType;

      switch (key) {
        // submission
        case "insert_submission":
        case "update_submission":
        case "delete_submission": {
          const { stn_submits, ...data } = response_data;
          manage_store_data({
            name: "submissions",
            key: "stn_id",
            data: stn_submits ? [data, ...stn_submits] : response_data,
            type: operationType,
          });
          break;
        }
        // results
        case "insert_results":
        case "update_results":
        case "delete_result": {
          const { results, submits, ...data } = response_data;
          manage_store_data({
            name: "results",
            key: "res_id",
            data: results ? [data, ...results] : response_data,
            type: operationType,
          });
          if (submits) {
            manage_store_data({
              name: "submissions",
              key: "stn_id",
              data: submits,
              type: "update",
            });
          }
          break;
        }
        // replies
        case "insert_replies":
        case "update_replies":
        case "delete_reply": {
          const { replies, submits, ...data } = response_data;
          manage_store_data({
            name: "replies",
            key: "rep_id",
            data: replies ? [data, ...replies] : response_data,
            type: operationType,
          });
          if (submits) {
            manage_store_data({
              name: "submissions",
              data: submits,
              type: "update",
              key: "stn_id",
            });
          }
          break;
        }
        // returns
        case "insert_returns":
        case "update_returns":
        case "delete_return": {
          const { returns, submits, ...data } = response_data;
          manage_store_data({
            name: "labouts",
            key: "ret_id",
            data: returns ? [data, ...returns] : response_data,
            type: operationType,
          });
          if (submits) {
            manage_store_data({
              name: "submissions",
              data: submits,
              type: "update",
              key: "stn_id",
            });
          }
          break;
        }
        // billing
        case "insert_bill":
        case "update_bill":
          const { submits, returns, sub_billing_lines, ...data } =
            response_data;
          manage_store_data({
            name: "bills",
            data: [data, ...sub_billing_lines],
            type: operationType,
            key: "bill_id",
          });
          if (submits) {
            manage_store_data({
              name: "submissions",
              data: submits,
              type: "update",
              key: "stn_id",
            });
          }
          if (returns) {
            manage_store_data({
              name: "labouts",
              data: returns,
              type: "update",
              key: "ret_id",
            });
          }
          break;
        // conversation Rate
        case "insert_cnv_rate":
        case "update_cnv_rate":
        case "delete_cnv_rate":
          manage_store_data({
            name: "conversionRate",
            key: "cnv_id",
            data: response_data,
            type: operationType,
          });
          break;

        // sizes

        case "insert_size":
        case "update_size":
        case "delete_size":
          manage_store_data({
            name: "sizes",
            key: "size_id",
            data: response_data,
            type: operationType,
          });
          break;
        // services
        case "insert_service":
        case "update_service":
        case "delete_service":
          manage_store_data({
            name: "services",
            key: "ser_id",
            data: response_data,
            type: operationType,
          });
          break;
        // parties
        case "insert_party":
        case "update_party":
        case "delete_party":
          manage_store_data({
            name: "parties",
            key: "p_id",
            data: response_data,
            type: operationType,
          });
          break;

        // priceList
        case "insert_pricelist":
        case "update_pricelist":
        case "delete_pricelist":
          manage_store_data({
            name: "priceList",
            key: "pl_id",
            data: response_data,
            type: operationType,
          });
          break;

        // users
        case "insert_user":
        case "update_user":
        case "delete_user":
          manage_store_data({
            name: "users",
            key: "u_id",
            data: response_data,
            type: operationType,
          });
          break;
        default:
          console.warn(`Unhandled socket operation: ${key}`);
      }
    });
  } else {
    console.error("Invalid socket data format - expected array of operations");
  }
};
